/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import SqlImportDatabaseModel from 'cio/models/sql-import-database';
import FormValidations from 'cio/utils/form-validations';
import { SqlImportDatabase } from 'cio/utils/sql-import';

interface SqlImportsCreateDatabaseTcpArgs {
  database?: SqlImportDatabaseModel;
  readOnly?: boolean;
  usesSSL: boolean;
  usesPort: boolean;
  validations: FormValidations;
  sqlServerIPAddress: string;
}

export default class SqlImportsCreateDatabaseTcp extends Component<SqlImportsCreateDatabaseTcpArgs> {
  @action
  toggleSSL() {
    this.args.database?.set('ssl', !this.args.database.ssl);
    if (this.args.database && !this.args.database?.ssl) {
      this.clearSslFields();
    }
  }

  @action
  onDatabaseValueChange(field: keyof SqlImportDatabaseModel, value: string) {
    this.args.database?.set(field, value);
    this.args.validations.validateAttribute(field);
  }

  private clearSslFields() {
    if (this.args.database?.type === SqlImportDatabase.mysql) {
      this.args.database?.set('sslServerCA', '');
      this.args.database?.set('sslClientKey', '');
      this.args.database?.set('sslClientCert', '');
    }
  }

  get hostPlaceholderText() {
    return this.isSnowflake ? 'account' : '';
  }

  get isSnowflake() {
    return this.args.database?.isSnowflake ?? false;
  }

  get showSslFields() {
    return Boolean(this.args.database?.ssl) && this.args.database?.isMySQL;
  }
}
